import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/Hero Section/HeroSection";
import Navbar from "../../components/Navbar/Navbar";
import SolutionsSection from "../../components/Solutions/SolutionsSection";

const SolutionsPage = () => {
  return (
    <div>
      <Navbar />
      <HeroSection variant={4} />
      <SolutionsSection />
      <Footer />
    </div>
  );
};

export default SolutionsPage;
